import {EditableSessionDateTimeInfo as Component} from './component';
import {useEditableSessionDateTimeRef} from './use-editable-session-time-ref';

export {type EditableSessionDateTimeRef, type ValidateOnMinDate} from './types';

export const EditableSessionDateTimeInfo = Object.assign(Component, {
	useRef: useEditableSessionDateTimeRef,
});
